import styled from 'styled-components';
import { H3Css } from 'components/ui/Typography';
import { black, blue, greyDark } from 'theme/colors';
import { spacing1x, spacing05x, spacing2x } from 'theme/spacings';
import { deviceSmallMax, deviceMediumMax } from 'theme/mediaQueries';
import RichTextWrapper from 'components/ui/RichText';
import { FaFacebookF, FaLinkedinIn, FaEnvelope } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
const IconCss = `
    color: ${black};
    font-size: 3.5rem;
    padding: ${spacing1x};
    margin-left: ${spacing05x};

    :hover {
        background-color: ${greyDark};
    }

    @media (max-width: 520px) {
        margin-left: 0;
        margin-right: ${spacing05x};
    }
`;

export const PublishInfoWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	width: 66%;
	@media (max-width: ${deviceMediumMax}) {
		width: 100%;
	}
	@media (max-width: 520px) {
		display: block;
	}
`;

export const Wrapper = styled.div`
	@media (max-width: 520px) {
		margin-top: ${spacing2x};
	}
`;

export const SocialLink = styled.a`
	margin: 0;
`;

export const FacebookIcon = styled(FaFacebookF)`
	${IconCss};
`;

export const TwitterIcon = styled(FaXTwitter)`
	${IconCss};
`;

export const LinedInIcon = styled(FaLinkedinIn)`
	${IconCss};
`;

export const EmailIcon = styled(FaEnvelope)`
	${IconCss};
`;

export const Image = styled.img`
	width: 66%;

	@media (max-width: ${deviceMediumMax}) {
		width: 100%;
	}
`;

export const RichText = styled(RichTextWrapper)`
	max-width: 66%;
	@media (max-width: ${deviceMediumMax}) {
		max-width: 100%;
	}
	@media (max-width: ${deviceSmallMax}) {
		margin: ${spacing05x} 0;
	}

	h2 {
		${H3Css};
		margin-bottom: ${spacing1x};
		color: ${blue};
	}

	p {
		margin: 0 0 ${spacing2x};
	}
`;
